import { useConfig } from '../defaultConfig';
import useStepUp from './useStepUp';

const useShowInstantPayment = (conditions: boolean[]) => {
    const { featureToggles } = useConfig();
    const stepup = useStepUp(conditions, featureToggles.enableImmediatePayment);
    return stepup.isHighAssurance || stepup.canStepup;
};

export default useShowInstantPayment;
